import { sendTicket } from 'Api/supportApi'
import { formatFormTicket } from 'Formatters/supportFormatter'

const state = {
  requesting: {
    newTicket: false,
  },

  ticket: '',
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_ticket(state, ticket) {
    state.ticket = ticket
  }
}

const actions = {
  async createTicket({ commit }, { user, company, type, message, cancellationReason }) {
    commit('request_start', 'newTicket')

    try {
      const ticket = formatFormTicket(user, company, type, message, cancellationReason)
      const { data } = await sendTicket(ticket)

      commit('request_success', 'newTicket')
      commit('set_ticket', data.identifier)

      return data
    } catch (err) {
      commit('request_failure', 'newTicket')

      throw err
    }
  },
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}